<template>
  <v-container>
    <v-app-bar app color="primary" dark >
      <v-app-bar-nav-icon @click="toggleDrawer"></v-app-bar-nav-icon>
      <v-text-field v-if="letSearch" autofocus v-model="search" placeholder="Search" hide-details outlined dense light class="white mr-3" clearable @clear="letSearch = false" style="width:100%"></v-text-field>
      <v-toolbar-title v-else v-text="$store.state.pageTitle"></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn v-if="!letSearch" dark class='primary darken-2 mr-3' icon @click="letSearch = true">
        <v-icon >mdi-magnify</v-icon>
      </v-btn>
      <v-btn dark class='primary darken-2' icon @click="createUser()">
        <v-icon >mdi-plus</v-icon>
      </v-btn>
    </v-app-bar>

    <v-data-table :headers="headers" :items="filteredUsers" :search="search">
      <template v-slot:item.UserProfile.city.city="{ item }">
        <div>
          {{ item.UserProfile.city.city }}
        </div>
      </template>

      <template v-slot:item.image1="{ item }">
        <div class="py-2" v-if="item.avatar">
          <v-img :src="`${$store.state.apiUrl}static/images/thumb/${item.image1}`" :width="80" :aspect-ratio="4/3"></v-img>
        </div>
      </template>
      <template v-slot:item.price="{ item }">
        {{ $toMoney(item.price) }}
      </template>

      <template v-slot:item.action="{ item }">
        <v-btn icon class="mr-3" @click="editUser(item)">
          <v-icon color="primary">mdi-pencil</v-icon>
        </v-btn>
        <v-btn icon @click="deleteUser(item.id)">
          <v-icon color="warning">mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <UserDialog ref="user"  @closeDialog="closeDialogUser"></UserDialog>

  </v-container>

</template>

<script>
  import UserDialog from '@/components/nano/UserDialog'

  export default {
    components: { UserDialog },
    data(){
      return {
        headers: [
          { text: 'Name', value: 'UserProfile.name', sortable: false },
          { text: 'Address', value: 'UserProfile.city.city', sortable: false },
          { text: 'Phone', value: 'UserProfile.phone', sortable: false },
          { text: 'Action', value: 'action', align: 'end', sortable: false },
        ],
        dialogUser: false,
        search: '',
        letSearch: false
      }
    },

    created(){
      // this.getUsers()
    },

    computed:{
      dialogUserTitle(){
        if(!this.dialogUser) return '';
        return (!this.user.id)  ? 'Add user' : 'Edit user';
      },
      dialogUserBtn(){
        if(!this.dialogUser) return '';
        return (!this.user.id)  ? 'Save' : 'Update';
      },
      filteredUsers(){
        return this.$store.state.users
      }
    },

    methods:{
      toggleDrawer(){
        this.$store.commit('mutate', { prop: 'drawer', data: !this.$store.state.drawer })
      },

      getUsers(){
        this.axios.get('users').then( (res) => {
          this.$store.commit('mutate', { prop: 'users', data: res.data })
        }).catch( (err) => {
          console.log(err)
        })
      },

      createUser(){
        this.$refs.user.dialogUser = true
      },

      editUser(user){
        this.$refs.user.dialogUser = true
        this.$refs.user.editedUser = JSON.parse(JSON.stringify(user))
      },

      closeDialogUser(){
        this.$refs.user.dialogUser = false
        this.$refs.user.editedUser = { email:'', UserProfile: { city: { type: '' } } }
        this.searchCity = ''
      },

      deleteUser(id){
        this.$swal({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            this.axios.delete('users/' + id).then( () => {
              this.getUsers();
              this.$store.commit('mutate', { prop: 'snackbar', data: { text: 'Deleted!', value:true } })
            }).catch(err => {
              this.$store.commit('mutate', { prop: 'snackbar', data: { text: err.response.data.msg, value:true } })
            })
          }
        })
      },

      createOrder(user){
        const order = {
          date: this.$moment().format(),
          userId: user.id,
          status: 'draft'
        }
        this.axios.post('orders', order).then( (res) => {
          this.$store.commit('mutate', { prop: 'order', date: res.data })
          this.$router.push('/order/' + res.data.id)
        })
      },

    }
  }
</script>

<style scoped>
</style>